// Side drawer for the file manager's asset preview
// (MoonScanWeb.Admin.AssetsLive.Index).
//
// The drawer is server-rendered — the parent LiveView owns :preview and
// handles close_preview. This hook covers what the server cannot: the
// Escape key, restoring focus to the element that opened the drawer, and
// locking body scroll while it is open.
const AssetDrawer = {
  mounted() {
    this._prevFocus = document.activeElement
    this._prevOverflow = document.body.style.overflow

    document.body.style.overflow = "hidden"
    this.el.focus()

    this._onKeydown = (e) => {
      if (e.key !== "Escape") return
      // An open modal (e.g. the delete confirm) owns Escape first.
      if (document.querySelector("dialog[open], .modal-open")) return
      e.preventDefault()
      this.pushEvent("close_preview", {value: {}})
    }
    window.addEventListener("keydown", this._onKeydown)
  },

  destroyed() {
    window.removeEventListener("keydown", this._onKeydown)
    document.body.style.overflow = this._prevOverflow

    if (this._prevFocus && typeof this._prevFocus.focus === "function") {
      this._prevFocus.focus()
    }
  },
}

export default AssetDrawer
